// import * as colorsData from 'aok-assets/src/base/colors/colors.json'
import * as colorsData from 'assets/aok-assets/src_base_colors_colors.json'
import * as breakpoints from './breakpoints'
import transitions from './transitions'

const pkColors = {}

// extract color names and create 1D key-value object
// with all possible color names mapped to their hex values
for (const colorData of colorsData.default.colors) {
  for (const colorName of colorData.variables) {
    pkColors[colorName] = `#${ colorData.hex_code }`
  }
}

export function createSpacing(spacingInput = 8) {
  if (spacingInput.init) {
    return spacingInput
  }

  let transform

  if (typeof spacingInput === 'function') {
    transform = spacingInput
  } else {
    if (typeof spacingInput !== 'number') {
      throw new Error(
        `The theme.spacing value (${ spacingInput }) is invalid, It should be a number or a function`
      )
    }
    transform = (factor) => {
      if (typeof factor !== 'number') {
        throw new Error(
          `Expected spacing argument to be a number, got ${ factor }`
        )
      }
      return spacingInput * factor
    }
  }

  const spacing = (...args) => {
    if (!(args.length <= 1)) {
      throw new Error(
        `Too many arguments provided, expected between 0 and 1, got ${ args.length }`
      )
    }

    if (args.length === 0) {
      return transform(1)
    }

    return transform(args[0])
  }
  spacing.init = true

  return spacing
}

/**
 * merge partial styles
 * @type {{color: {Button: {active: string, disabled: string}, colors: {hellGruen1: string, dunkelGruen1: string, dunkelGruen2: string, standardSchwarz: string, aokOrange: string, hellGruen2: string, hintergrundPrio2: string, hellGruen3: string, weiss: string, hintergrundPrio3: string, dunkelorange: string, aokGruen: string, gesundnah: string, grau1: string, grau2: string, fehlerRot: string, iconGrau1: string, iconGrau2: string, iconGrau3: string, hintergrundAllgemein: string}}}}
 */
const theme = {
  colors: {
    ...pkColors,
    boxShadow: 'rgba(0,0,0,0.13)',
    barGraphForeground: '#4E93B6',
    barGraphBackground: '#C4D8E3',
    barGraphPercentValue: '#069',
    sortSelectTitle: '#d3d3d2',
    sortSelectOptions: '#e4e4e5',
    divider: '#d0d0d0',
    'icon-grau-0': '#6b6b6b',
    'divider-detail-link-list': '#e6e6e6',
    partingLine: '#979797',
    openTimeClosedSoon: '#ffcc01',
    compareBestValueIndicator: 'rgba(0, 138, 52, 0.1)',
    compareSelectBackground: '#d0d1d1',
  },

  // for keeping track of z-index pitfalls
  zIndices: {
    dropdown: '1',
    overlay: '2',
    modal: '104',
    fullscreenMap: '200',
    floatingMenu: 1,
  },
  breakpoints,
  spacing: createSpacing(5),
  transitions,
}

export default theme
